import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";

const DeleteConfirmation = ({
  show,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item?",
  onConfirm,
  onCancel,
  loading = false,
}) => {
  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
      style={{
        background: "rgba(0,0,0,0.55)",
        backdropFilter: "blur(4px)",
        zIndex: 9999,
      }}
    >
      <div
        className="bg-white rounded-4 shadow-lg overflow-hidden"
        style={{
          width: "90%",
          maxWidth: "450px",
          animation: "fadeIn 0.2s ease",
        }}
      >
        {/* Header */}
        <div
          className="text-center text-white p-4"
          style={{
            background:
              "linear-gradient(135deg, #dc3545 0%, #b02a37 100%)",
          }}
        >
          <div
            className="mx-auto d-flex align-items-center justify-content-center rounded-circle bg-white"
            style={{
              width: "70px",
              height: "70px",
            }}
          >
            <FaExclamationTriangle
              size={35}
              color="#dc3545"
            />
          </div>

          <h4 className="mt-3 mb-0 fw-bold">
            {title}
          </h4>
        </div>

        {/* Body */}
        <div className="p-4">
          <div
            className="alert alert-danger border-0"
            role="alert"
          >
            <strong>Warning!</strong>
            <br />
            This action cannot be undone.
          </div>

          <p
            className="text-center text-secondary mb-4"
            style={{ fontSize: "15px" }}
          >
            {message}
          </p>

          <div className="d-flex gap-2">
            <button
              className="btn btn-light border flex-fill"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger flex-fill"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  />
                  Deleting...
                </>
              ) : (
                "Delete Permanently"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;